/**
 * Centralized logging utility
 * In production, logs can be sent to logging service
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log('[LOG]', ...args);
    }
  },
  
  error: (...args) => {
    // Always log errors, but can be sent to error tracking service
    if (isDevelopment) {
      console.error('[ERROR]', ...args);
    }
    // In production, send to error tracking service (e.g., Sentry)
  },
  
  warn: (...args) => {
    if (isDevelopment) {
      console.warn('[WARN]', ...args);
    }
  },
  
  info: (...args) => {
    if (isDevelopment) {
      console.info('[INFO]', ...args);
    }
  }
};

export default logger;

